import { isAndroid } from '../../utils/platformUtils'
import { Text, View, StyleSheet, Image, Dimensions, TouchableOpacity, Animated, ActivityIndicator, Platform } from 'react-native'
import theme from '../../../theme'
import { colorText } from '../../../themeConstants'
import { TriviaTheme } from '../../../themeConstants'
const isWeb = Platform.OS === 'web'
const { width, height } = Dimensions.get('window')

const styles = StyleSheet.create({
    invisibleContainer: {
        flexDirection: 'column',
        padding: 0,
        justifyContent: 'center',
    },
    container: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        paddingTop: !isWeb ? 5 : 15,
        paddingBottom: 15,
    },
    feedbackAssetContainer: {
        width: !isWeb ? 52 : undefined,
        aspectRatio: 1,
        marginRight: 12,
        marginLeft: 12,

        alignSelf: 'center',
        zIndex: 2,
    },
    feedbackAsset: {
        width: isAndroid() ? 42 : 42,
        flex: 1,
        aspectRatio: 1,
        zIndex: 2,
    },
    levelKnowledgeBlock: {
        flex: 1,
        marginHorizontal: 0,
        zIndex: 1,
    },
    alignStart: {
        alignItems: 'flex-start',
    },
    containerData: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    title: {
        fontSize: 16,
        color: TriviaTheme.triviaCardTextColor,
        fontWeight: 'bold',
        marginBottom: isWeb ? 12 : 0,
    },
    subtitle: {
        fontSize: 13,
        color: !isWeb ? TriviaTheme.triviaCardTextColor : theme.colors.textPrimary,
        marginVertical: -5,
        paddingBottom: 10,
        textTransform: 'capitalize',
    },
    value: {
        fontSize: !isWeb ? 30 : 16,
        fontWeight: 'bold',
        color: TriviaTheme.triviaCardTextColor,
        marginBottom: 12,
    },
    containerTrivias: {
        flex: 1,
        paddingTop: 10,
    },
    containerRanking: {
        flex: 1,
        backgroundColor: 'white',
    },
})

export default styles
